<div class="booking-flow-container" fxLayout="column">
  <div class="info-card p-2">
    <mat-horizontal-stepper class="custom-horizontal-stepper" style="padding-bottom: 0" [selectedIndex]="currentStep"
                            #stepper
                            [linear]="true"
                            (selectedIndexChange)="currentStep = $event">
      @for (step of steps; track step.label; let i = $index) {
        <mat-step [tabIndex]="i" [stepControl]="step.control" [editable]="step.editable">
          <ng-template matStepLabel>{{ step.label }}</ng-template>
        </mat-step>
      }
    </mat-horizontal-stepper>
  </div>

  @if (isCurrentStep('calendar')) {
    <app-calendar-view [spaces]="[]"
                       [offering]="offering"
                       [sharedSpaceAvailabilityMap]="spaceAvailabilityMap"
                       [isSubLease]="true"
                       [availableSharedSpaces]="availableSharedSpace"
                       [subLeases]="subLeases"
                       [dateConfigs]="dateConfigs"
                       [overlappingLeaseSharedSpaces]="overlappingLeaseSpaces"
                       [loadingSpaceData]="loadingSpaceData"
                       [(bookingConfig)]="bookingConfig"
                       [editType]="editType"
                       (focusMonthChanged)="loadMoreSpaceData($event)"
                       (quickDateSelection)="loadMoreSpaceDataForDateRange($event.dateRange, $event.dateSelection)"
                       (updateAvailableSpaces)="updateAvailableSpace($event)"
                       (updateOverlappingLeases)="updateOverlappingLeaseSpaces($event)"
                       (createBookingEvent)="nextStep()"></app-calendar-view>
  }

  @if (isCurrentStep('dates_and_spaces')) {
    <app-booking-dates-and-spaces [availableSharedSpace]="availableSharedSpace"
                                  [isSubLease]="true"
                                  [editType]="editType"
                                  [lease]="lease ?? null"
                                  [(bookingConfig)]="bookingConfig"
                                  (updateAvailableSpaces)="updateAvailableSpace($event)"
                                  (next)="nextStep()"
                                  (previous)="previousStep()">
    </app-booking-dates-and-spaces>
  }

  @if (isCurrentStep('rates_and_charges')) {
    <app-booking-shared-rates-and-charges [bookingConfig]="bookingConfig"
                                          [retailerId]="retailerId"
                                          [parentPricingPeriods]="parentPricingPeriods"
                                          [editType]="editType"
                                          [lease]="lease ?? null"
                                          [pricingPeriod]="pricingPeriod ?? null"
                                          (next)="nextStep()"
                                          (previous)="previousStep()"></app-booking-shared-rates-and-charges>
  }

  @if (isCurrentStep('tenant_info')) {
    <app-booking-tenant-info [(bookingConfig)]="bookingConfig"
                             [offering]="offering"
                             [retailerLookupOptions]="retailerLookupOptions()"
                             (next)="nextStep()"
                             (previous)="previousStep()"></app-booking-tenant-info>
  }

  @if (isCurrentStep('review_and_submit')) {
    <app-booking-review-contract [bookingConfig]="bookingConfig"
                                 [isSubLease]="true"
                                 [parentLease]="parentLease"
                                 [offeringId]="offeringId"
                                 [offering]="offering"
                                 [editType]="editType"
                                 [lease]="lease ?? null"
                                 (submit)="submitBooking($event)"
                                 (previous)="previousStep()"></app-booking-review-contract>
  }

</div>
